module.exports = __webpack_public_path__ + "img/slika42.65347c94.jpg";